import alt from "../alt";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";

class GlobalNotificationStore {
  constructor() {
    this.bindActions(GlobalNotificationActions);

    this.state = {
      open: false,
      message: ""
    };
  }

  onNotify(message) {
    this.setState({ open: true, message: message });
  }

  onClose() {
    this.setState({ open: false });
  }
}

export default alt.createStore(
  GlobalNotificationStore,
  "GlobalNotificationStore"
);



// WEBPACK FOOTER //
// ./src/app/stores/GlobalNotificationStore.js